import React from "react";
import { ArrowRight, ShieldCheck, Network, Zap } from "lucide-react";
import { IMG, TRUST_BADGES } from "@/lib/content";

const trustIcons = [ShieldCheck, Zap, Network];

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      <img
        src={IMG.hero}
        alt="Xortec Kameramast im professionellen Außeneinsatz"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 hero-mask" />
      <div className="absolute inset-0 bg-grid-dark opacity-30" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-32 pb-20 md:pt-40 md:pb-28 min-h-[100svh] flex flex-col justify-end">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="dot-pulse" />
            <span
              data-testid="hero-tagline"
              className="text-xs font-mono-tech uppercase tracking-[0.25em] text-white/80"
            >
              Sicherheits­infrastruktur · KRITIS · NIS2
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display font-semibold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
          >
            Die ganzheitliche Infrastruktur für{" "}
            <span className="text-[#5BA8FF]">moderne Sicherheits- und Infrastrukturprojekte</span>
          </h1>

          <p
            data-testid="hero-subline"
            className="mt-6 text-base sm:text-lg lg:text-xl text-white/85 leading-relaxed max-w-2xl"
          >
            Xortec verbindet neben Video- und Einbruchmeldeanlagen auch Masten,
            Netzwerk- und Anschlusstechnik zu einer durchdachten Gesamtlösung
            für professionelle Sicherheits- und Infrastrukturprojekte.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="#kontakt"
              data-testid="hero-cta-projekt"
              className="group inline-flex items-center justify-center gap-2 bg-[#0055A4] hover:bg-[#003e7a] text-white px-7 py-3.5 rounded-md font-medium transition-colors shadow-lg shadow-[#0055A4]/20"
            >
              Projekt anfragen
              <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
            </a>
            <a
              href="/konfigurator"
              data-testid="hero-cta-konfigurator"
              className="group inline-flex items-center justify-center gap-2 bg-[#0055A4] hover:bg-[#003e7a] text-white px-7 py-3.5 rounded-md font-medium transition-colors shadow-lg shadow-[#0055A4]/20"
            >
              Kameramast konfigurieren
              <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
            </a>
          </div>

          <div
            data-testid="hero-trust-badges"
            className="mt-14 flex flex-wrap gap-x-8 gap-y-4"
          >
            {TRUST_BADGES.map((b, i) => {
              const Icon = trustIcons[i % trustIcons.length];
              return (
                <div
                  key={b}
                  className="flex items-center gap-2.5 text-white/85 text-sm font-medium"
                >
                  <Icon className="h-4 w-4 text-[#5BA8FF]" />
                  {b}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 hidden md:flex items-center gap-3 text-white/60 text-xs font-mono-tech">
        <div className="h-px w-10 bg-white/40" />
        SCROLL
      </div>
    </section>
  );
}
